<template>
  <SnackBar
    @cancel="$emit('cancel')"
    @save="$emit('save')"
    :model-value="modelValue"
    :processing="processing"
    :timeout="-1"
    data-testid="save-bar"
    text="You have unsaved changes."
    cancelable
    saveable
  />
</template>

<script setup>
import SnackBar from '@/shared/components/SnackBar.vue';

defineEmits(['cancel', 'save']);

defineProps({
  modelValue: Boolean,
  processing: Boolean,
});
</script>
